export const LEDGERS = "Ledgers"
export const ADD_LEDGER  = "Add Ledger"
export const EDIT_LEDGER  = "Edit Ledger"
export const SAVE = "Save Ledger"
export const DELETE_LEDGER = "Delete Ledger";

export const FETCH = "Fetch"


export const LEDGER_TABLE_CELLS = [
    { id: 'name',label: 'Name',align: "left"},
    { id: 'balance',label: 'Balance',align: "left"},
    { id: 'details',label: ''},
];

export const CARRIER_TABLE_CELLS = [
    {id: 'carrierName', label: 'Standard Carrier', align: 'left'},
    {id: 'CY_SUBTOTAL_PAYABLE', label: 'Amount', align: 'center'},
];

export const FTL_CARRIER_TABLE_CELLS = [
    {id: 'carrierName', label: 'LTL/FTL Carrier', align: 'left'},
    {id: 'CY_SUBTOTAL_PAYABLE', label: 'Amount', align: 'center'},
];

export const MARKETPLACE_TABLE_CELLS = [
    {id: 'name', label: 'Marketplace', align: 'left'},
    {id: 'totalBalance', label: 'Amount', align: 'center'},
];

export const SUPPLIER_TABLE_CELLS = [
    {id: 'supplierName', label: 'Supplier', align: 'left'},
    {id: 'CY_SUBTOTAL_PAYABLE', label: 'Amount', align: 'center'},
];

export const CUSTOMER_TABLE_CELLS = [
    {id: 'name', label: 'Customer', align: 'left'},
    {id: 'totalBalance', label: 'Amount', align: 'center'},
];

export const BANK_ACCOUNT_SUMMARY_TABLE_CELLS = [
    {id: 'name', label: 'Bank Balances', align: 'left'},
    {id: 'totalBalance', label: 'Amount', align: 'center'},
];

export const CREDIT_CARD_BALANCES_SUMMARY_TABLE_CELLS = [
    {id: 'name', label: 'Credit Card Balances', align: 'left'},
    {id: 'totalBalance', label: 'Amount', align: 'center'},
];

export const OUTSTANDING_CHEQUES_SUMMARY_TABLE_CELLS = [
    {id: 'name', label: 'Outstanding Cheques', align: 'left'},
    {id: 'totalBalance', label: 'Amount', align: 'center'},
];

export const SALES_TABLE_CELLS = [
    {id: 'name', label: 'Sales', align: 'left'},
    {id: 'totalBalance', label: 'Amount', align: 'center'},
];

export const STOCK_IN_HAND_TABLE_CELLS = [
    {id: 'name', label: 'Stock', align: 'left'},
    {id: 'balance', label: 'Amount', align: 'center'},
];

export const MARKETPLACE_ENTRIES_CELLS = [

    { id: 'description',label: 'Description',align: "left"},
    { id: 'debit',label: 'Debit',align: "left"},
    { id: 'credit',label: 'Credit',align: "left"},
    { id: 'balance',label: 'Balance',align: "center"},

];

export const LEDGER_ENTRIES_CELLS = [

    { id: 'date', label: 'Date', align: "left"},
    { id: 'description',label: 'Description',align: "left"},
    { id: 'debit',label: 'Debit',align: "left"},
    { id: 'credit',label: 'Credit',align: "left"},
    { id: 'balance',label: 'Balance',align: "center"},

];

export const LEDGER_PAYABLE_ENTRIES_CELLS = [
     {id: 'description', label: 'Other', align: "left"},
     { id: 'credit',label: 'Amount',align: "center"},
];


export const LEDGERS_PAGES = {
    TABLE: "table",
    EDIT: "Edit Ledgers",
    FORM: "Edit Ledger Rule",
    AUDIT: "Ledger Audit",

}

export const SOURCE_OPTIONS = [
    "Transactions",
    "Ledgers",
    "",
];

export const SUM_RULE_OPTIONS = [
    "Sum of Subtotal",
    "Sum of Taxes",
    "Sum of Total",
];

export const CARRY_FORWARD_OPTIONS = [
    "Yes",
    "No",
];

// tooltip names
export const BACK = "Back to Menu"

export const MARKETPLACE_MAPPING = {
    amazon_ca: 'Amazon.ca',
    amazon_com: 'Amazon.com',
    walmart_ca: 'Walmart.ca',
    walmart_com: 'Walmart.com',
    ebay_ca: 'eBay.ca',
    exponet_ca: 'Exponet.ca',
    exponet_us: 'Exponet.ca (US)',
    customer_ca: 'Customers',
};

export const DEFAULT_SORT_BY_LEDGER_NAME_CELL = 'name';